let assembly: WebAssembly.WebAssemblyInstantiatedSource;

let memory: {
    buffer: ArrayBuffer
};

let HEAPF32: Float32Array;
let HEAP32: Int32Array;
let HEAPU8: Uint8Array;

let _sampleAlloc: Function;
let _pitchDetector2: Function;

const decoder = new TextDecoder();
function emptyFunction() { }
function fd_write(fd, iov, iovcnt, pnum) {

    let num = 0;

    const parts: string[] = [];

    for (var i = 0; i < iovcnt; i++) {

        var ptr = HEAP32[((iov) >> 2)];
        var len = HEAP32[(((iov) + (4)) >> 2)];
        iov += 8;

        parts.push(decoder.decode(HEAPU8.subarray(ptr, ptr + len)));
      
        num += len;
    }

    HEAP32[((pnum) >> 2)] = num;

    console.log(parts.join(""));

    return 0;
}

export async function loadMathLibAsync() {

    if (assembly)
        return;

    const response = await fetch("math.wasm");

    const args = {
        "fd_close": emptyFunction,
        "fd_seek": emptyFunction,
        "fd_write": fd_write,
        "proc_exit": emptyFunction
    };

    assembly = await WebAssembly.instantiateStreaming(response, {
        env: args,
        wasi_snapshot_preview1: args
    });

    const exports = assembly.instance.exports;

    memory = exports["memory"] as any;
    _sampleAlloc = exports["sampleAlloc"] as Function;
    _pitchDetector2 = exports["pitchDetector2"] as Function;

    HEAPF32 = new Float32Array(memory.buffer);
    HEAPU8 = new Uint8Array(memory.buffer);
    HEAP32 = new Int32Array(memory.buffer);
}


export function sampleAlloc(size: number) {

    const buffer = _sampleAlloc(size) as number;

    return HEAPF32.subarray(buffer >> 2, (buffer >> 2) + size)
}

export function pitchDetector2(sampleSize: number) {

    return _pitchDetector2(sampleSize) as number;
}